import React from 'react';
import { TFunction } from 'i18next';
import moment from 'moment';
import CheckIcon from '@mui/icons-material/Check';
// @ts-ignore
import variables from 'styles/_variables.scss';
import { DAY_MONTH_YEAR_SLASH } from 'utils';
import { CloseIcon, CsvIcon } from '../components/icons';
import { ICompanyMailingList } from '../modules/admin-panel/pages/clients/models';

const mailingListsTableHeaders: string[] = [
	'Mailing list title',
	'File',
	'New',
	'Total',
	'Date Added',
];

export const mailingListsTableHeaderRow: JSX.Element = (
	<tr>
		{mailingListsTableHeaders.map((header: string) => (
			<th key={header}>{header}</th>
		))}
	</tr>
);

export const renderMailingListsTableRow = (
	mailingList: ICompanyMailingList,
	t: TFunction,
	onDeleteList?: () => void,
): JSX.Element => (
	<tr key={mailingList.mailingListKey}>
		<td>
			<CsvIcon iconClass="dropzone__icon-file" />
			<span
				className="dropzone__name-uploaded"
				title={mailingList.mailingListKey}
			>
				{mailingList.mailingListKey}
			</span>
		</td>
		<td>{mailingList.employeesCount}</td>
		<td>{mailingList.newEmployeesCount}</td>
		<td>{mailingList.totalEmployeesCount}</td>
		<td>{moment(mailingList.dateAdded).format(DAY_MONTH_YEAR_SLASH)}</td>
		<td>
			{onDeleteList ? (
				<CloseIcon
					pointer
					iconClass="dropzone__icon-delete"
					onClick={onDeleteList}
				/>
			) : (
				<CheckIcon htmlColor={variables.accentColor} />
			)}
		</td>
	</tr>
);
